import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, useRef } from "react";
import parseClassnames from "../helpers/parseClassnames.js";
import useRect from "../helpers/useRect.js";
import helpers_getPosition from "./helpers/getPosition.js";
import getStylesAndCollissions from "./helpers/getStylesAndCollissions.js";
import { renderTriangleBasedOnCollisionsAndPosition } from "./Triangles.js";
const TooltipContent = ({ position = 'top', getPosition = helpers_getPosition, isVisible, triggerRect, style, type, className = '', htmlProps, ...rest }, forwardedRef)=>{
    const ownRef = useRef(null);
    const ref = forwardedRef || ownRef;
    const tooltipRect = useRect(ownRef, isVisible);
    const [absolutePositionStyles, collisions] = getStylesAndCollissions(getPosition, triggerRect, tooltipRect, position);
    if ('large' === type && 'title' in rest) {
        const { title, description, buttonOkLabel, buttonDissmissLabel, ...tooltipContentProps } = rest;
        console.log(type, title);
        return /*#__PURE__*/ jsx("div", {
            role: "tooltip",
            style: {
                ...style,
                ...absolutePositionStyles
            },
            ref: ref,
            className: parseClassnames(className, "tw-absolute tw-rounded-[0.5rem] tw-p-0.8 tw-inline-block tw-w-[30rem] tw-pt-2 tw-px-2 tw-pb-1.2 tw-bg-neutral-light-100 tw-shadow-01"),
            ...tooltipContentProps,
            ...htmlProps,
            children: /*#__PURE__*/ jsxs("span", {
                className: "",
                children: [
                    /*#__PURE__*/ jsx("span", {
                        className: "tw-font-label1 tw-mb-0.4 tw-line-clamp-1",
                        children: title
                    }),
                    /*#__PURE__*/ jsx("span", {
                        className: "tw-font-body5 tw-mb-0.4 tw-line-clamp-3",
                        children: description
                    }),
                    /*#__PURE__*/ jsxs("span", {
                        className: "tw-flex tw-mt-1.2",
                        children: [
                            buttonDissmissLabel && /*#__PURE__*/ jsx("button", {
                                type: "button",
                                children: buttonDissmissLabel
                            }),
                            buttonOkLabel && /*#__PURE__*/ jsx("button", {
                                type: "button",
                                className: "tw-ml-auto",
                                children: buttonOkLabel
                            })
                        ]
                    })
                ]
            })
        });
    }
    if ('small' === type && 'label' in rest) {
        const { label, ...tooltipContentProps } = rest;
        return /*#__PURE__*/ jsxs("div", {
            role: "tooltip",
            style: {
                ...style,
                ...absolutePositionStyles
            },
            ref: ref,
            className: parseClassnames(className, "tw-absolute tw-rounded-[0.5rem] tw-p-0.8 tw-inline-block tw-font-body5 tw-z-dialog tw-pointer-events-none tw-whitespace-no-wrap tw-bg-neutral-dark-700 dark:tw-bg-neutral-light-200 tw-text-neutral-light-100 dark:tw-text-neutral-light-800"),
            ...tooltipContentProps,
            ...htmlProps,
            children: [
                renderTriangleBasedOnCollisionsAndPosition(collisions, position),
                label
            ]
        });
    }
    return null;
};
const Tooltip_TooltipContent = /*#__PURE__*/ forwardRef(TooltipContent);
export default Tooltip_TooltipContent;
